import React, { useMemo } from 'react'
import styles from '../Home.module.less'
import { HeaderTabs } from 'Components/common/HeaderTabs/HeaderTabs'
import { TaskQueuesTab } from 'Pages/Home/tabs/tasks/TaskQueuesTab.tsx'
import { FeedbackTab } from 'Pages/Home/tabs/tasks/FeedbackTab.tsx'
import SavedTasksScreen from 'Components/common/SavedForLater/SavedTasksScreen.tsx'

export const TasksTab: React.FC = () => {
    const tabItems = useMemo(
        () => [
            {
                key: 'available-tasks',
                label: 'Available Tasks',
                children: <TaskQueuesTab />,
            },
            {
                key: 'feedback',
                label: 'Feedback',
                children: <FeedbackTab />,
            },
            {
                key: 'tasks-saved-for-later',
                label: 'Tasks Saved For Later',
                children: <SavedTasksScreen />,
            },
        ],
        []
    )

    return (
        <div className={styles['tasks-tab']}>
            <HeaderTabs items={tabItems} />
        </div>
    )
}
